// extracted by mini-css-extract-plugin
module.exports = {"container":"content_blocks_image_text_internal_link-module--container--1kJXO","text":"content_blocks_image_text_internal_link-module--text--V5tpq"};